import React, { useEffect, useRef } from "react";
import { CssBaseline, withWidth } from "@material-ui/core";
import OverView from "./overview";
import { Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AuthActions } from "../../../../../modules/redux";
import { dashboardStyles } from "../../../../../styles";
import { AuthState, UserData } from "../../../../../modules/redux/Auth/reducer";
import { CurrentState } from "../../../../../const";
import { GRAPH_REQUESTS, msalApp } from "../../../../Authentication/auth-utils";
import { InteractionRequiredAuthError } from "msal";
import LoginRedirect from "./LoginRedirect";
import Offering from "./offering";
import Benefits from "./benefits";
import Contact from "./contact";
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";
import Register from "./Register";
import { UserService } from "../../../../User/actions";
import { RoleService } from "../../../../Role/actions";
import { RequestTrialService as RegisterService } from "../../../action";

function ManageX(props) {
  const dispatch = useDispatch();
  const classes = dashboardStyles();
  const auth = useSelector((state) => state.auth);
  const appSettings = useSelector((state) => state.appSettings);
  const offerRef = useRef();
  const homeRef = useRef();
  const benefitRef = useRef();
  const contactRef = useRef();
  const requestTrial = useRef();
  const [selectTab, setSelectTab] = React.useState("home");
  const [loginErrorMessage, setLoginErrorMessage] = React.useState("");
  const [loginRequestStatus, setLoginRequestStatus] = React.useState(false);
  const [requestTrialLoading, setRequestTrialLoading] = React.useState(false);
  const [showRequestTrailMessage, setShowRequestTrialMessage] =
    React.useState(false);
  const [disableError, setDisableError] = React.useState(false);
  const [signInClick, setSignInClick] = React.useState(false);
  const [cookiesState, setCookiesState] = React.useState(
    getCookieConsentValue("cookies")
  );

  const [error, setError] = React.useState(false);
  const [emailError, setEmailError] = React.useState(false);
  const [signupAllowedDomainError, setSignupAllowedDomainError] =
    React.useState(false);
  const [pathUrl, setPathUrl] = React.useState(window.location.pathname);

  const initForm = {
    firstname: "",
    lastname: "",
    email: "",
    org: "",
    jobTitle: "",
    country: "",
    purpose: ""
  };

  const [formData, setFormData] = React.useState(initForm);
  const [signupWilling, setSignupWilling] = React.useState(false);
  const [formError, setFormError] = React.useState({
    firstname: true,
    lastname: true,
    email: true,
    org: true,
    jobTitle: true,
    country: true,
    purpose: true
  });

  function signUp() {
    setSignupWilling(true);
    let errorSubmission = false;
    for (const [key, value] of Object.entries(formError)) {
      if (value) {
        setError(true);
        errorSubmission = true;
        break;
      }
    }

    if (!errorSubmission) {
      setError(false);
      let params = { ...formData };

      setRequestTrialLoading(true);

      params["name"] = params.firstname + " " + params.lastname;

      RegisterService.Request(params)
        .then((res) => {
          setDisableError(false);
          setShowRequestTrialMessage(true);
          setRequestTrialLoading(false);
          setLoginRequestStatus(res.data.success);
          setLoginErrorMessage(res.data.message);
          window.scrollTo(0, 0);
          setFormData(initForm);
          setSignupWilling(false);
        })
        .catch((err) => {
          setDisableError(false);
          setLoginRequestStatus(false);
          setShowRequestTrialMessage(true);
          setLoginErrorMessage("Error in the Submission");
          setRequestTrialLoading(false);
          window.scrollTo(0, 0);
          setFormData(initForm);
        });
    }
  }

  function handleMenuClick(key) {
    switch (key) {
      case "home":
        homeRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "benefits":
        benefitRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "contact":
        contactRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "offer":
        offerRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "requestTrail":
        requestTrial.current.scrollIntoView({ behavior: "smooth" });
        break;
      default:
        homeRef.current.scrollIntoView({ behavior: "smooth" });
        break;
    }
    setSelectTab(key);
  }

  useEffect(() => {
    document.title = `ManageX Research`;
  }, []);

  useEffect(() => {
    if (
      !signInClick &&
      props.width !== "xs" &&
      props.width !== "sm" &&
      (auth.state === AuthState.LOGIN_REQUEST ||
        auth.state === AuthState.SET_TOKEN)
    ) {
      setSignInClick(true);
    }

    if (signInClick && auth.state === AuthState.LOGIN_ERROR) {
      setSignInClick(false);
    }
  }, [auth.state]);

  if (auth.state === AuthState.SWITCH_DIRECTORY) {
    dispatch(AuthActions.login(auth, appSettings.msService));
  }

  if (auth.state === AuthState.LOGIN_REQUEST) {
    setTimeout(function () {
      let currentState = CurrentState();
      if (currentState === AuthState.LOGIN_REQUEST) {
        dispatch(
          AuthActions.logout(
            "Request Timeout Error(Error Code - 408). Please disable popup blockers for this site and try again."
          )
        );
      }
    }, 120000);
  }

  if (auth.state === AuthState.SET_TOKEN) {
    setTimeout(function () {
      let currentState = CurrentState();
      if (currentState === AuthState.SET_TOKEN) {
        dispatch(
          AuthActions.logout(
            "Request Timeout Error(Error Code - 408). Please disable popup blockers for this site and try again."
          )
        );
      }
    }, 60000);
  }

  function authCallback(error, loginResponse) {
    const setToken = (result) => {
      return {
        type: AuthState.SET_TOKEN,
        payload: result
      };
    };
    const request = () => {
      return {
        type: AuthState.LOGIN_REQUEST
      };
    };
    const success = (result, account = UserData.account) => {
      return {
        type: AuthState.LOGGED_IN,
        payload: result,
        account: account,
        lastUrl: ""
      };
    };

    function stateUpdate(loginResponse, azureResponse) {
      function funcCallback(err, result) {
        if (err) {
          dispatch(AuthActions.logout(err.toString()));
        } else {
          loginResponse.accessToken = result.accessToken;
          loginResponse.azureToken = azureResponse.accessToken;
          loginResponse.secondaryAzureToken = azureResponse.accessToken;

          dispatch(setToken(loginResponse));

          UserService.GetLoginUserDetails(
            result.accessToken,
            azureResponse.accessToken
          )
            .then((res) => {
              if (res.data.success) {
                if (res.data?.data?.isLimitedAccess) {
                  let todayUnix = Math.floor(Date.now() / 1000);
                  if (
                    todayUnix >= res.data.data.from &&
                    todayUnix <= res.data.data.to
                  ) {
                    RoleService.GetDataByUsingKeyAndOrgKey(
                      res.data.data.role,
                      res.data.data.orgInfo.orgId,
                      result.accessToken,
                      azureResponse.accessToken
                    ).then((roleResult) => {
                      if (roleResult.status !== 204) {
                        if (
                          roleResult?.data?.status?.toLowerCase() === "active"
                        ) {
                          if (res.data.data.orgInfo.isCustomSubscription) {
                            UserService.GetAzureToken().then(
                              (azureTokenResult) => {
                                res.data.data.roleInfo = roleResult.data;
                                loginResponse.secondaryAzureToken =
                                  azureTokenResult.data.data;
                                dispatch(success(loginResponse, res.data.data));
                              }
                            );
                          } else {
                            res.data.data.roleInfo = roleResult.data;
                            dispatch(success(loginResponse, res.data.data));
                          }
                        } else {
                          dispatch(
                            AuthActions.logout(
                              `User role in ${roleResult.data.status} State. Please contact admin.`
                            )
                          );
                        }
                      } else {
                        dispatch(
                          AuthActions.logout(
                            `User role not found. Please contact admin.`
                          )
                        );
                      }
                    });
                  } else {
                    dispatch(
                      AuthActions.logout(
                        `User can access the portal from ${new Date(
                          res.data.data.from * 1000
                        )} to ${new Date(
                          res.data.data.to * 1000
                        )}. Please contact admin.`
                      )
                    );
                  }
                } else {
                  RoleService.GetDataByUsingKeyAndOrgKey(
                    res.data.data.role,
                    res.data.data.orgInfo.orgId,
                    result.accessToken,
                    azureResponse.accessToken
                  ).then((roleResult) => {
                    if (roleResult.status !== 204) {
                      if (
                        roleResult?.data?.status?.toLowerCase() === "active"
                      ) {
                        if (res.data.data.orgInfo.isCustomSubscription) {
                          UserService.GetAzureToken().then(
                            (azureTokenResult) => {
                              res.data.data.roleInfo = roleResult.data;
                              loginResponse.secondaryAzureToken =
                                azureTokenResult.data.data;
                              dispatch(success(loginResponse, res.data.data));
                            }
                          );
                        } else {
                          res.data.data.roleInfo = roleResult.data;
                          dispatch(success(loginResponse, res.data.data));
                        }
                      } else {
                        dispatch(
                          AuthActions.logout(
                            `User role in ${roleResult.data.status} State. Please contact admin.`
                          )
                        );
                      }
                    } else {
                      dispatch(
                        AuthActions.logout(
                          `User role not found. Please contact admin.`
                        )
                      );
                    }
                  });
                }
              } else {
                dispatch(AuthActions.logout(res.data.message));
              }
            })
            .catch((err) => {
              dispatch(AuthActions.logout(err.toString()));
            });
        }
      }
      let instance = msalApp(loginResponse.tenantId, appSettings.msService);
      instance.handleRedirectCallback(funcCallback);
      instance
        .acquireTokenSilent(GRAPH_REQUESTS.PROFILE(appSettings.msService))
        .then((result) => funcCallback(null, result))
        .catch((err) => {
          if (err instanceof InteractionRequiredAuthError) {
            instance
              .acquireTokenPopup(GRAPH_REQUESTS.PROFILE(appSettings.msService))
              .then((result) => funcCallback(null, result))
              .catch((err) => funcCallback(err, null));
          } else {
            funcCallback(err, null);
          }
        });
    }

    try {
      if (loginResponse) {
        dispatch(request());
        msalApp(loginResponse.tenantId, appSettings.msService)
          .acquireTokenSilent(GRAPH_REQUESTS.AZURE_SCOPE(appSettings.msService))
          .then((azureResponse) => {
            stateUpdate(loginResponse, azureResponse);
          })
          .catch((err) => {
            if (err instanceof InteractionRequiredAuthError) {
              function azureAuthCallback(error, azureResponse) {
                if (error) {
                  dispatch(AuthActions.logout(error.toString()));
                } else {
                  stateUpdate(loginResponse, azureResponse);
                }
              }
              msalApp(
                loginResponse.tenantId,
                appSettings.msService
              ).handleRedirectCallback(azureAuthCallback);
              msalApp(
                loginResponse.tenantId,
                appSettings.msService
              ).acquireTokenRedirect(
                GRAPH_REQUESTS.AZURE_SCOPE(appSettings.msService)
              );
            } else {
              if (err instanceof InteractionRequiredAuthError) {
                msalApp(loginResponse.tenantId, appSettings.msService)
                  .acquireTokenPopup(
                    GRAPH_REQUESTS.AZURE_SCOPE,
                    appSettings.msService
                  )
                  .then((azureResponse) => {
                    stateUpdate(loginResponse, azureResponse);
                  })
                  .catch((err) => {
                    dispatch(AuthActions.logout(err.toString()));
                  });
              } else {
                dispatch(AuthActions.logout(err.toString()));
              }
            }
          });
      } else {
        dispatch(AuthActions.logout("Popup Canceled"));
      }
    } catch (err) {
      dispatch(AuthActions.logout(err.toString()));
    }
  }

  useEffect(() => {
    msalApp(auth.tenantId, appSettings.msService).handleRedirectCallback(
      authCallback
    );
  });

  useEffect(() => {
    setLoginErrorMessage(auth.errorMsg);
    setDisableError(false);
  }, [auth]);

  return (
    <React.Fragment>
      {auth.state !== AuthState.LOGGED_IN ||
      auth.state === AuthState.SWITCH_DIRECTORY ? (
        signInClick ? (
          <div>
            <LoginRedirect
              setSignInClick={setSignInClick}
              signInClick={signInClick}
              auth={auth}
              onSignIn={() => {
                dispatch(AuthActions.login(auth, appSettings.msService));
              }}
            />
          </div>
        ) : (
          <div style={{ overflowX: "hidden" }} ref={homeRef}>
            <CookieConsent
              style={{
                backgroundColor: "#ffffff",
                color: "#2b2b2b",
                padding: "12px 32px",
                alignItems: "center"
              }}
              location="bottom"
              buttonText="ACCEPT"
              cookieName="cookies"
              buttonStyle={{
                backgroundColor: "#1a273e",
                color: "#fff",
                textAlign: "center",
                borderRadius: 5,
                alignItems: "center",
                fontSize: "14px",
                padding: "12px 32px"
              }}
              onAccept={(byScroll) => {
                setCookiesState(getCookieConsentValue("cookies"));
              }}
            >
              <div style={{ fontWeight: 500, fontSize: 16 }}>
                Cookie Consent
              </div>
              <br />
              <div style={{ fontSize: 12 }}>
                By continuing to browse or by clicking Accept, you agree to the
                storing of cookies on your device to enhance your site
                experience and for analytical purposes. To learn more about how
                we use the cookies, please see our{" "}
                <u>
                  <a
                    style={{ textDecoration: "none", color: "#2b2b2b" }}
                    href="https://terawe.com/Cookies"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    cookies policy
                  </a>
                </u>
                .
              </div>
            </CookieConsent>
            <CssBaseline />
            <main
              className={classes.layout}
              style={{ position: "absolute", overflowX: "hidden" }}
            >
              <OverView
                selectTab={selectTab}
                setShowRequestTrialMessage={setShowRequestTrialMessage}
                handleMenuClick={handleMenuClick}
                classes={classes}
                setSignInClick={setSignInClick}
                auth={auth}
                AuthState={AuthState}
                onSignIn={() => {
                  dispatch(AuthActions.login(auth, appSettings.msService));
                }}
                pathUrl={pathUrl}
                setPathUrl={setPathUrl}
                setDisableError={setDisableError}
                disableError={disableError}
                showRequestTrailMessage={showRequestTrailMessage}
                loginRequestStatus={loginRequestStatus}
                loginErrorMessage={loginErrorMessage}
              />
              <Offering offerRef={offerRef} handleMenuClick={handleMenuClick} />
              <Benefits benefitRef={benefitRef} />
              <Register
                formData={formData}
                setFormData={setFormData}
                setFormError={setFormError}
                formError={formError}
                requestTrialLoading={requestTrialLoading}
                signUp={signUp}
                requestTrial={requestTrial}
                error={error}
                setLoginRequestStatus={setLoginRequestStatus}
                setLoginErrorMessage={setLoginErrorMessage}
                setShowRequestTrialMessage={setShowRequestTrialMessage}
                signupWilling={signupWilling}
              />
              <Contact contactRef={contactRef} cookiesState={cookiesState} />
            </main>
          </div>
        )
      ) : (
        <Redirect
          to={
            auth.provider === "aws-auth"
              ? `/portal/aws/s3bucket`
              : !auth.account.roleInfo || !auth.account.roleInfo.landingPage
              ? `/portal`
              : "/portal" + auth.account.roleInfo.landingPage
          }
        />
      )}
    </React.Fragment>
  );
}

export default withWidth()(ManageX);
